import React, { lazy, Suspense, useEffect, useState } from 'react';

const InteractiveGallery = lazy(() => import('react-image-gallery'));

export default function PhotoGallery(props) {
  const [interactive, setInteractive] = useState(false);
  useEffect(() => setInteractive(true), []);
  const fallback = (
    <div className="retro-static-gallery">
      {props.items.map((item, index) => (
        <a href={item.original} key={`${item.original}-${index}`}>
          <img src={index === 0 ? item.original : item.thumbnail || item.original} alt={item.originalAlt || `Zdjęcie ${index + 1}`} loading="lazy" />
        </a>
      ))}
    </div>
  );
  return interactive ? <Suspense fallback={fallback}><InteractiveGallery {...props} /></Suspense> : fallback;
}
